import { FileDown, FileText, Eye, Wand2, MousePointerClick } from "lucide-react";

const maskDate = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 8);
  let out = d.slice(0, 2);
  if (d.length > 2) out += "." + d.slice(2, 4);
  if (d.length > 4) out += "." + d.slice(4, 8);
  return out;
};

const Field = ({ field, value, onChange }) => {
  const common = {
    id: field.name,
    "data-testid": `field-${field.name}`,
    value: value || "",
    onChange: (e) => onChange(field.name, e.target.value),
    className: "papir-input",
    placeholder: field.placeholder || "",
  };
  return (
    <div className={field.type === "textarea" ? "sm:col-span-2" : ""}>
      <label htmlFor={field.name} className="papir-label">
        {field.label}
        {field.required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      {field.type === "textarea" ? (
        <textarea rows={3} {...common} />
      ) : field.type === "select" ? (
        <select {...common}>
          <option value="">odaberite...</option>
          {(field.options || []).map((o) => (
            <option key={o} value={o}>{o}</option>
          ))}
        </select>
      ) : field.type === "date" ? (
        <input
          type="text"
          inputMode="numeric"
          {...common}
          placeholder="dd.mm.gggg."
          onChange={(e) => onChange(field.name, maskDate(e.target.value))}
        />
      ) : (
        <input type={field.type === "number" ? "number" : "text"} {...common} />
      )}
    </div>
  );
};

export default function DocumentForm({ doc, formData, setFormData, onAutofill, onGenerate, onPreview, busy }) {
  if (!doc) {
    return (
      <div className="bg-white border border-slate-200 rounded-2xl p-10 shadow-sm text-center fade-in-up" data-testid="empty-state">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center mb-4">
          <MousePointerClick className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-lg font-semibold text-slate-900">Odaberite dokument s popisa</h3>
        <p className="text-sm text-slate-500 mt-2 max-w-md mx-auto">
          Kliknite na kategoriju i dokument koji vam treba, ispunite podatke, a mi ćemo pripremiti
          uredan službeni dokument spreman za preuzimanje.
        </p>
      </div>
    );
  }

  const onChange = (name, value) => setFormData((prev) => ({ ...prev, [name]: value }));

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 shadow-sm fade-in-up" data-testid="document-form-container" key={doc.id}>
      <p className="text-xs font-semibold tracking-wider uppercase text-slate-500 mb-2">2. Ispunite podatke</p>
      <div className="flex flex-wrap items-start justify-between gap-3 mb-6">
        <div>
          <h3 className="text-xl font-bold text-slate-900">{doc.title}</h3>
          <p className="text-sm text-slate-500 mt-1">{doc.description}</p>
        </div>
        <button
          data-testid="auto-fill-profile-btn"
          onClick={onAutofill}
          className="flex items-center gap-2 bg-blue-50 hover:bg-blue-100 text-blue-700 font-semibold px-3.5 py-2 rounded-xl border border-blue-200 transition-all text-sm"
        >
          <Wand2 className="w-4 h-4" />
          Popuni iz mog profila
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {doc.fields.map((f) => (
          <Field key={f.name} field={f} value={formData[f.name]} onChange={onChange} />
        ))}
      </div>
      <div className="flex flex-wrap gap-3 mt-8 pt-6 border-t border-slate-100">
        <button
          data-testid="preview-document-btn"
          onClick={onPreview}
          disabled={busy}
          className="flex items-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold px-5 py-2.5 rounded-xl border border-slate-200 transition-all disabled:opacity-50"
        >
          <Eye className="w-4 h-4" />
          Pregled dokumenta
        </button>
        <button
          data-testid="download-docx-btn"
          onClick={() => onGenerate("docx")}
          disabled={busy}
          className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white font-semibold px-5 py-2.5 rounded-xl shadow-sm transition-all disabled:opacity-50"
        >
          <FileText className="w-4 h-4" />
          Preuzmi .docx
        </button>
        <button
          data-testid="download-pdf-btn"
          onClick={() => onGenerate("pdf")}
          disabled={busy}
          className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white font-semibold px-5 py-2.5 rounded-xl shadow-sm transition-all disabled:opacity-50"
        >
          <FileDown className="w-4 h-4" />
          Preuzmi PDF
        </button>
      </div>
    </div>
  );
}
